import { render, staticRenderFns } from "./CragSectorDescription.vue?vue&type=template&id=4d51b4ac"
import script from "./CragSectorDescription.vue?vue&type=script&lang=js"
export * from "./CragSectorDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports